import { useRef } from 'react';
import dayjs from 'dayjs';

interface IDatePickerProps {
  value: string | null | undefined;
  // eslint-disable-next-line no-unused-vars
  handleOnChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  className?: string;
  label?: string;
  disabled?: boolean;
}

function DatePicker({ value, handleOnChange, className, label, disabled }: IDatePickerProps) {
  const inputRef = useRef<HTMLInputElement>(null);
  const handledValue = value && dayjs(value).isValid() ? dayjs(value).format('YYYY-MM-DD') : '';

  const openPicker = () => {
    if (disabled) return;
    inputRef.current?.showPicker?.(); // opens calendar
    inputRef.current?.focus(); // fallback
  };

  return (
    <div onClick={openPicker} className={className ?? ''}>
      <input ref={inputRef} type="date" aria-label={label} disabled={disabled} value={handledValue} onChange={handleOnChange} />
    </div>
  );
}

export default DatePicker;
